import React from 'react';
import { Step } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/step.less';

export default Step;
